const faqs=[
{
id:1,
question:"What documents are required to rent a vehicle?",
answer:"Original ID proof, such as a driver's license or passport, is needed to rent a vehicle."
},
{
id:2,
question:"Are fuel charges included in the rental prices?",
answer:"The rental charges do not include fuel prices. The renter is responsible for refueling the vehicle.",
},
{
    id:3,
    question:"Is a security deposit required?",
    answer:"A security deposit of INR 2000 will be collected by the owner at the time of vehicle pickup. This deposit is refundable or adjustable at the time of returning the vehicle.",
    },
    {
        id:4,
        question:"What happens if the terms and conditions are violated?",
        answer:"If any of the terms and conditions are violated, it may lead to legal proceedings. All renters are expected to adhere to the rental agreement's terms and conditions.",
        },
]

export default faqs;